<script lang="ts" setup>
const props = defineProps<{
  walletId: string;
  address: string;
  caipAddress: string;
}>();

const emit = defineEmits(["verified"]);
const unsupported = ref<false | "ledger">(false);

function onVerificationError(payload: { reason: string }) {
  if (payload.reason === "ledger") {
    unsupported.value = "ledger";
  }
}

onMounted(() => {
  trackEvent("ui_verify_wallet_ownership_modal_opened", {
    trigger: "button_verify_ownership_clicked",
    wallet_id: props.walletId,
  });
});

onBeforeUnmount(() => {
  trackEvent("ui_verify_wallet_ownership_modal_closed", {
    trigger: "button_verify_wallet_ownership_modal_dismiss_clicked",
    wallet_id: props.walletId,
  });
});
</script>
<template>
  <div>
    <p class="text-[#707070] text-lg font-semibold">
      Verify ownership of your wallet
    </p>

    <p class="text-lg">{{ address }}</p>

    <div class="mt-8 space-y-5">
      <WalletsVerifyWallet
        element="button"
        :wallet-id="walletId"
        :caip-address="caipAddress"
        class="p-6 w-full text-left border shadow border-[#dddddd] transition-all duration-150 ease-out bg-gradient-to-b from-transparent to-[#B0B0B0]/20 rounded-2xl hover:border-white hover:bg-none hover:bg-white"
        @verified="emit('verified')"
        @error="onVerificationError"
      >
        <div class="flex items-center">
          <IconsAccountBalanceIcon />
          <p class="text-lg ml-[6px]">Sign a Message</p>
        </div>

        <p class="text-sm mt-3 text-black/60">
          Safe and easy way to verify ownership of your wallet
        </p>
      </WalletsVerifyWallet>

      <!-- <a
        href="mailto:support@evangelist.gg"
        data-analytics-click-id="tile_verify_wallet_ownership_modal_contact_support_clicked"
        data-analytics-event="contact_support_mailto_user_verify_wallet_opened"
        class="p-6 block w-full text-left border hover:shadow-shadow-blur border-[#dddddd] transition-all duration-150 ease-out bg-gradient-to-b from-transparent to-[#B0B0B0]/20 rounded-2xl hover:border-white hover:bg-none hover:bg-white"
      >
        <div class="flex items-center">
          <IconsAccountBalanceIcon />
          <p class="text-lg ml-[6px]">Contact our Support</p>
        </div>

        <p class="text-sm mt-3 text-black/60">
          <span v-if="unsupported === 'ledger'" class="text-black/90">
            Signing off messages with Ledger is not supported.
          </span>

          We will walk you through a manual verification process.
        </p>
      </a> -->
    </div>

    <p class="text-[#707070] mt-10">
      Verify wallet ownership by signing a message using your wallet browser
      extension.
    </p>
  </div>
</template>
